module.exports = __webpack_public_path__ + "static/media/backgroundImg.7d8c1d85.png";